<div class="impersonation-banner" *ngIf="isImpersonating">
  <div class="impersonation-banner-content">
    <i class="fas fa-user-secret me-2"></i>
    <span class="impersonation-text">
      Viewing as <strong>{{ impersonatedUserName }}</strong>
      <span class="role-badge ms-2">{{ impersonatedUserRole }}</span>
    </span>
    <button 
      type="button" 
      class="btn btn-sm btn-exit ms-3"
      (click)="exitImpersonation()"
      [disabled]="isExiting">
      <span *ngIf="isExiting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      <i *ngIf="!isExiting" class="fas fa-sign-out-alt me-1"></i>
      {{ isExiting ? 'Exiting...' : 'Exit' }}
    </button>
  </div>
</div>
